import { Component, type ErrorInfo, type ReactNode } from 'react';
import { PageShell } from './ui';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  public override state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error in UI tree:', error, errorInfo);
  }

  public override render() {
    if (this.state.hasError) {
      return (
        <PageShell>
          <div className="ucc-panel mx-auto my-12 max-w-lg border-loss/40 p-8 text-center shadow-2xl">
            <div className="mx-auto mb-4 flex size-14 items-center justify-center rounded-full bg-loss/15 text-loss">
              <svg className="size-7 text-loss" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
                <line x1="12" x2="12" y1="9" y2="13" />
                <line x1="12" x2="12.01" y1="17" y2="17" />
              </svg>
            </div>
            <h2 className="ucc-display text-2xl text-paper">Ocorreu um erro ao carregar a tela</h2>
            <p className="mt-2 text-sm text-muted">
              {this.state.error?.message || 'Não foi possível processar os dados desta visualização.'}
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-3">
              <button
                type="button"
                onClick={() => {
                  this.setState({ hasError: false, error: null });
                  window.location.reload();
                }}
                className="rounded-lg border border-line-strong px-5 py-2.5 text-sm font-semibold text-paper transition-colors hover:border-gold/50"
              >
                Recarregar página
              </button>
              <a
                href="/"
                className="rounded-lg bg-gold px-5 py-2.5 text-sm font-semibold text-black transition-colors hover:bg-gold-bright"
              >
                Voltar para o início
              </a>
            </div>
          </div>
        </PageShell>
      );
    }

    return this.props.children;
  }
}
